import { ReactNode } from 'react';

import { Button } from '@iwoca/orion';

export const ContinueButton = ({
    onClick,
    disabled,
    children
}: {
    onClick?: () => void;
    disabled?: boolean;
    children: ReactNode;
}) => (
    <Button
        className="w-full rounded-full text-primary-10"
        variant="secondary-alt"
        onClick={onClick}
        disabled={disabled}
    >
        {children}
    </Button>
);
